module.exports = "<router-outlet></router-outlet>\n<ng4-loading-spinner [timeout]=\"12000\" [loadingText]=\"'Cargando...'\"></ng4-loading-spinner>\n"